/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Email_Element_Not_FoundInputs */

const en_error_email_element_not_found = /** @type {(inputs: Error_Email_Element_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`That part of the email is no longer there: someone may have removed it.`)
};

/**
* | output |
* | --- |
* | "That part of the email is no longer there: someone may have removed it." |
*
* @param {Error_Email_Element_Not_FoundInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const error_email_element_not_found = /** @type {((inputs?: Error_Email_Element_Not_FoundInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Email_Element_Not_FoundInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_error_email_element_not_found(inputs)
});